export enum LinkReleaseTriggerMode {
  ALWAYS = 'always',
  HOLD_SHIFT = 'hold shift',
  NOT_HOLD_SHIFT = 'NOT hold shift'
}

export enum LinkReleaseTriggerAction {
  CONTEXT_MENU = 'context menu',
  SEARCH_BOX = 'search box',
  NO_ACTION = 'no action'
}
